(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    }

    function renderBold(el, text) {
      var parts = text.split('**');
      el.textContent = '';
      if (parts.length === 3) {
        el.appendChild(document.createTextNode(parts[0]));
        var strong = document.createElement('strong');
        strong.textContent = parts[1];
        el.appendChild(strong);
        el.appendChild(document.createTextNode(parts[2]));
      } else {
        el.textContent = text;
      }
    }

    function updateBar(bar, cartTotal) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      var phraseBelow = bar.dataset.phraseBelow;
      var phraseAbove = bar.dataset.phraseAbove;
      var messageEl = bar.querySelector('[data-free-shipping-message]');
      if (!messageEl) return;

      if (cartTotal >= threshold) {
        renderBold(messageEl, phraseAbove);
      } else {
        var remaining = threshold - cartTotal;
        renderBold(messageEl, phraseBelow.replace('{amount}', formatMoney(remaining)));
      }
    }

    function refreshBars() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.m-free-shipping-bar').forEach(function (bar) {
            updateBar(bar, cart.total_price);
          });
        });
    }

    document.addEventListener('DOMContentLoaded', refreshBars);
    document.addEventListener('cart:refresh', refreshBars);
    document.addEventListener('cart:updated', refreshBars);
    document.addEventListener('cart-drawer:open', refreshBars);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["giftback-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    }

    function updateGiftbackBar(bar, productPrice) {
      var percentage = parseFloat(bar.dataset.percentage);
      var phrase = bar.dataset.phrase;
      var brand = bar.dataset.brand;
      var messageEl = bar.querySelector('[data-giftback-message]');
      if (!messageEl) return;

      var giftbackCents = Math.round(productPrice * percentage / 100);
      var formatted = formatMoney(giftbackCents);
      var text = phrase.replace('{amount}', formatted);

      var textNode = document.createTextNode(text + ' ');
      var strong = document.createElement('strong');
      strong.textContent = brand;

      messageEl.textContent = '';
      messageEl.appendChild(textNode);
      messageEl.appendChild(strong);
    }

    function refreshAllGiftbackBars(productPrice) {
      document.querySelectorAll('.m-giftback-bar').forEach(function (bar) {
        updateGiftbackBar(bar, productPrice);
      });
    }

    function getInitialPrice() {
      var bar = document.querySelector('.m-giftback-bar');
      if (bar) {
        return parseInt(bar.dataset.productPrice, 10) || 0;
      }
      return 0;
    }

    document.addEventListener('DOMContentLoaded', function () {
      refreshAllGiftbackBars(getInitialPrice());
    });

    document.addEventListener('variant:change', function (event) {
      if (event.detail && event.detail.variant && event.detail.variant.price) {
        document.querySelectorAll('.m-giftback-bar').forEach(function (bar) {
          bar.dataset.productPrice = event.detail.variant.price;
        });
        refreshAllGiftbackBars(event.detail.variant.price);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["low-stock-alert"] && !Shopify.designMode) return;
  try {
    (function () {
    function updateAlert(variant) {
      document.querySelectorAll('.m-low-stock-alert').forEach(function (el) {
        var threshold = parseInt(el.dataset.threshold, 10);
        var messageTemplate = el.dataset.message;
        var messageEl = el.querySelector('[data-low-stock-message]');
        var inventory = variant.inventory_quantity;
        var managed = variant.inventory_management;

        if (managed && inventory > 0 && inventory < threshold) {
          el.style.display = 'flex';
          if (messageEl) {
            messageEl.textContent = messageTemplate.replace('{quantity}', inventory);
          }
        } else {
          el.style.display = 'none';
        }
      });
    }

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        updateAlert(e.detail.variant);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-popup"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSearchCloseBtn() {
    var btn = document.querySelector('[data-close-search-inline]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var searchEl = document.querySelector('m-search-popup');
      if (searchEl && typeof searchEl.closeSearchPopup === 'function') {
        searchEl.closeSearchPopup();
      }
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        MinimogEvents.emit(MinimogTheme.pubSubEvents.closeSearchPopup);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchCloseBtn);
  } else {
    initSearchCloseBtn();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
